export const DATE_FORMAT_INTERNAL = 'yyyy-MM-dd';
